var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import PopoverWrapper from './PopoverWrapper';
var PopoverUncontrolled = /** @class */ (function (_super) {
    __extends(PopoverUncontrolled, _super);
    function PopoverUncontrolled(props) {
        var _this = _super.call(this, props) || this;
        _this.togglePopover = function () {
            var isOpen = _this.state.isOpen;
            _this.setState({ isOpen: !isOpen });
        };
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    PopoverUncontrolled.prototype.render = function () {
        var _a = this.props, size = _a.size, className = _a.className, disabled = _a.disabled, trigger = _a.trigger, target = _a.target, placement = _a.placement, autoHide = _a.autoHide, children = _a.children;
        var isOpen = this.state.isOpen;
        var resultClassName = 'gr-popover ' + (size ? size : 'xl') + ' ' + (className ? className : '');
        return (React.createElement(PopoverWrapper, { target: target, placement: placement, trigger: trigger || 'legacy', isOpen: isOpen, role: 'popover', toggle: this.togglePopover, disabled: disabled, className: resultClassName, autoHide: autoHide || true, children: children }));
    };
    return PopoverUncontrolled;
}(Component));
export default PopoverUncontrolled;
//# sourceMappingURL=PopoverUncontrolled.js.map